<template>
  <div class="sm:flex flex-wrap items-center mt-4 mb-4">
    <div v-if="preview" class="w-20 h-20 p-1 flex-shrink-0 rounded bg-gray-200 mr-2">
      <img class="object-contain h-full w-full" :src="preview" alt="preview" />
    </div>
    <div class="flex-1">
      <input
        type="file"
        ref="fileInput"
        id="file"
        class="hidden"
        :accept="accept"
        @change="imageSelected()"
      />
      <button
        type="button"
        class="block w-full sm:w-40 btn btn-secondary px-2 font-semibold rounded-lg mx-1"
        @click="$refs.fileInput.click()"
      >
        Select Image
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "FilePicker",
  props: {
    type: {
      type: String,
      required: false,
      default: 'image',
      validator: type => {
        return Array('image').includes(type)
      }
    }, 
    value: {
      type: String,
      required: false,
    }
  },

  data() {
    return {
      image: false
    };
  },

  computed: {
    preview() {

      if (!this.image && this.value) {
        return this.value
      } else if (!this.image) {
        return
      }

      if (this.type == "image") {
        return URL.createObjectURL(this.image);
      }
    },

    accept() {
      if (this.type == "image") {
        return "image/jpeg, image/png, image/gif";
      }
    }
  },

  methods: {
    imageSelected() {
      this.image = this.$refs.fileInput.files[0];

      this.$emit('change', this.image);
    }
  }
};
</script>
